import React, { Component } from 'react';
import StepHeader from '../../includes/StepHeader';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import ManagePaymentActionCreator from '../../actions/ManagePaymentActionCreator';
import EditPaymentsStore_new from '../../stores/EditPaymentsStore_new';
import ActiveDirectDebitFields from './activepayments/ActiveDirectDebitFields';
import CancelDirectDebitModal from './activepayments/CancelDirectDebitModal';
import CancelStandingOrderModal from './activepayments/CancelStandingOrderModal';
import ActiveStandingOrderRepeatingFields from './activepayments/ActiveStandingOrderRepeatingFields';
import { CalloutComponent } from '../common/CalloutComponent';
import ActiveStandingOrderSingleFields from './activepayments/ActiveStandingOrderSingleFields';
import StringConstant from '../../constants/StringConstants';
import Helmet from 'react-helmet';
import AnalyticsUtil from '../../utils/AnalyticsUtil';
import config from '../../config/index';
import UserManagementStore from '../../stores/UserManagementStore';
import PrintHelper from 'print-helper-lib';
import envConfig from '../../../static/config';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';

let _isNominatedUser = false;

class ViewPayment extends Component {
  constructor(props) {
    super(props);
    this.showSubHeader = this.showSubHeader.bind(this);
    this.viewPayment = this.viewPayment.bind(this);
    this.showCancelPaymentModal = this.showCancelPaymentModal.bind(this);
    this.state = {
      viewData: EditPaymentsStore_new.getPaymentData(),
      showCancelPaymentModal: false,
    };
  }

  componentWillMount() {
    _isNominatedUser = UserManagementStore.isNominatedUser();
  }

  componentDidMount() {
    AnalyticsUtil.analyticAction(
      config.analytics.analytics_experience_view,
      config.analytics.analytics_event_method_appeared,
      'PageLoaded'
    );
    sayLandingMessage(
      `${this.props.content.viewPaymentHeader}${this.state.viewData.paymentType}`
    );
  }

  editPayment() {
    ManagePaymentActionCreator.editBackReference('WEB-VIEW-PAYMENT');
    ManagePaymentActionCreator.navigateToWebTask('WEB-EDIT-PAYMENT');
  }

  goBack() {
    ManagePaymentActionCreator.navigateToWebTask('WEB-MANAGE-PAYMENT');
  }

  showCallOutForComplexSO() {
    if (
      this.state.viewData.category === 'SO' &&
      !this.state.viewData.isSoWrite
    ) {
      return (
        <CalloutComponent
          className="c-alert c-alert--warning"
          paraText={this.props.content.toolTipMessageComplexSO}
        />
      );
    } else {
      return null;
    }
  }

  showCancelModal() {
    switch (this.state.viewData.category) {
      case 'DD':
        return (
          <CancelDirectDebitModal
            closeModal={this.showCancelPaymentModal}
            cancelPaymentData={this.state.viewData}
            content={this.props.content}
          />
        );
      case 'SO':
        return (
          <CancelStandingOrderModal
            closeModal={this.showCancelPaymentModal}
            cancelPaymentData={this.state.viewData}
            content={this.props.content}
          />
        );
    }
  }

  showCancelPaymentModal() {
    if (this.state.showCancelPaymentModal) {
      this.goBack();
    } else {
      this.setState({
        showCancelPaymentModal: !this.state.showCancelPaymentModal,
      });
    }
  }

  showOptions() {
    const editPayment =
      this.state.viewData.category === 'SO' &&
      this.state.viewData.isSoWrite &&
      !_isNominatedUser ? (
        <button
          onClick={this.editPayment}
          className="c-btn c-btn--secondary c-btn--view-payment"
        >
          {StringConstant.edit}
        </button>
      ) : null;
    return (
      <p>
        <button
          onClick={this.goBack}
          className="c-btn c-btn--secondary c-btn--view-payment"
        >
          {StringConstant.back}
        </button>
        &nbsp;
        {editPayment}
        &nbsp;
        {_isNominatedUser ? (
          ''
        ) : (
          <button
            className="c-btn c-btn--default c-btn--view-payment"
            onClick={this.showCancelPaymentModal}
          >
            {StringConstant.cancelPayment}
          </button>
        )}
      </p>
    );
  }

  showSubHeader() {
    return <h3>{this.state.viewData.paymentType}</h3>;
  }

  viewPayment() {
    if (this.state.viewData.category === 'DD') {
      return <ActiveDirectDebitFields activeData={this.state.viewData} />;
    } else {
      if (this.state.viewData.soType === 'SINGLE') {
        return (
          <ActiveStandingOrderSingleFields activeData={this.state.viewData} />
        );
      } else {
        return (
          <ActiveStandingOrderRepeatingFields
            activeData={this.state.viewData}
          />
        );
      }
    }
  }

  render() {
    return (
      <div>
        <Helmet title="View Payment" />
        <div className="bow page manage-payment-page">
          <div className="container" id="site-main" role="main" tabIndex="-1">
            <div className="row">
              <div className="col-xs1-24 col-md1-18">
                {/* <span id="accessH1ID" tabIndex="0" className="u-visually-hidden off-screen" ref="accessH1ID">You are on {this.props.content.viewPaymentHeader} {this.state.viewData.paymentType}</span> */}
                <StepHeader
                  showheaderCrumbs
                  onClick={this.goBack}
                  headerCrumbsMessage="Back"
                  headerTitle={this.props.content.viewPaymentHeader}
                  headerSubtitle={this.state.viewData.paymentType}
                />
                <PrintHelper
                  className="web-ui-components"
                  brandId={envConfig.brandId}
                  showPrintTopIcon
                  showPrintBottomIcon={false}
                />
                {this.showCallOutForComplexSO()}
                {this.viewPayment()}
                {this.showOptions()}
              </div>
            </div>
          </div>
        </div>
        {this.state.showCancelPaymentModal ? this.showCancelModal() : null}
      </div>
    );
  }
}

export default RequiresAuthenticatedUser(ViewPayment);
